// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b325c508","845":"217fdaeb"}[chunkId] + ".chunk.js";
};